/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'add-config': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M659.2 576l108.096 108.096-83.2 83.2-235.392-235.392v-39.808L684.096 256.64l83.2 83.2L659.2 448H1024v128H659.2zM0 0h960v128H0V0zm384 448H0V320h384v128zm0 256H0V576h384v128zm576 320H0V896h960v128z"/>'
  }
})
